import { ModalFormButton, FormFieldsData } from 'framework/form';
import { useAuthorization } from 'framework/authorization';
import { ExpertisePermission } from 'domain/people/employee/expertise/service/expertiseService.model';
import { useIsMyProfile } from 'domain/shared/employee';
import useExpertiseService from 'domain/people/employee/expertise/service/expertiseService';
import { useCallback } from 'react';
import createExpertiseValidationSchema from './createExpertiseValidationSchema';
import CreateExpertiseForm from './CreateExpertiseForm';

const CreateExpertiseAction = () => {
  const isMyProfile = useIsMyProfile();
  const { createExpertise } = useExpertiseService();
  const onSubmit = useCallback(
    (values: FormFieldsData) => {
      return createExpertise({ displayName: values.name, allowedPositionAliases: values.positionIds });
    },
    [createExpertise],
  );
  const { isGranted } = useAuthorization();

  if (!isGranted(ExpertisePermission.PEOPLE_MANAGEMENT_EXPERTISE_DEFINITION_CREATE) || isMyProfile) {
    return null;
  }

  return (
    <ModalFormButton
      formTitle="Create new expertise"
      getValidationSchemaFunc={async () => createExpertiseValidationSchema}
      label="Create new expertise"
      submitFormFunc={onSubmit}
      submitButtonText="Create"
      buttonProps={{ link: true }}
    >
      <CreateExpertiseForm />
    </ModalFormButton>
  );
};

export default CreateExpertiseAction;
